import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gx-4 gx-lg-5 padding-bottom-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-green" }, "Kontakta oss")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 pt-5 mb-2" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:micke@nghantverk.se" }, "micke@nghantverk.se")
  ])
], -1)
const _hoisted_4 = { class: "col-12 mt-5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-arrow-left",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  })
], -1)

import { useRouter, useRoute } from 'vue-router';
    import { onMounted } from 'vue';
    import { useMeta } from '@/composables/meta';
    import { useCanonical } from '@/composables/canonical';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();

    const goBack = () => {
        router.go(-1);
    };

    onMounted(async () => {
        useMeta('Kontakta oss', 'Här hittar du information om hur du kan komma i kontakt med oss.');
        useCanonical(route.path.substring(1));
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn btn-outline-primary btn-custom-size",
        onClick: _withModifiers(goBack, ["prevent"])
      }, [
        _hoisted_6,
        _createTextVNode(" TILLBAKA ")
      ], 8, _hoisted_5)
    ])
  ]))
}
}

})